<div id="host">
  <h2>{{ 'security-policies-nav-active-list' | translate }}</h2>
  @if (!loadingOerror()) {
  <div class="d-flex flex-row align-items-start">
    @if (mapPolicies.size > 0) {
    <div class="canevasList d-flex flex-column">
      @for (item of mapPolicies | keyvalue: originalOrder; track item) {
      <div>
        @if(item.value && item.value.length > 0 && isAdmin()) {
        <div class="d-flex flex-row align-items-center head">
          <h3 class="text-capitalize">{{ item.key }}</h3>
        </div>
        }@else{ <div class="d-flex flex-row align-items-center head">
          <img class="headimg" src="assets/icons/logosOS/{{ item.key[0] }}.svg">
          <h3 class="text-capitalize">{{ item.key[1] }}</h3>
        </div>
        }
        @for (policy of item.value; track policy) {
        <div type="button" class="d-flex flex-row justify-content-around align-items-center policy"
          id="elem{{ supprEsp(policy.name.toLowerCase()) }}{{ policy.id }}"
          (click)="policySelectionnee(policy); scrollTo()">
          <div class="d-flex flex-column policnamebwv">
            <h4 class="elemTitre">{{ policy.name }}</h4>
            <h6>{{ policy.bwVersion?.version }}</h6>
          </div>
          <hr class="elemListehr">
          <img class="os" src="assets/icons/logosOS/{{ policy.bwVersion?.os?.toLowerCase() }}.svg">
          <img placement="top" ngbTooltip="{{ getState(policy) }}" src="{{ getStateImage(policy) }}">
          <div class="d-flex flex-column date">
            @if (policy.activationDate && policy?.status == 'ACTIVATED') {
            <h4 class="elemTitre text-center">
              {{ 'security-policies-active-list-activation-date' | translate }}
            </h4>
            <div class="d-flex flex-column text-center">
              <h5>{{ timestampToDate(policy.activationDate) }}</h5>
              <h6>{{ horaire(policy.activationDate) }}</h6>
            </div>
            }
            @if (policy?.status == 'SUBMITTED' && policy.submittedDate) {
            <h4 class="elemTitre text-center">
              {{ 'security-policies-active-list-proposition-date' | translate }}
            </h4>
            <div class="d-flex flex-column text-center">
              <h5>{{ timestampToDate(policy.submittedDate) }}</h5>
              <h6>{{ horaire(policy.submittedDate) }}</h6>
            </div>
            }
            @if (policy?.status == 'DESACTIVATED' && policy.desactivationDate) {
            <h4 class="elemTitre text-center">
              {{ 'security-policies-active-list-desactivation-date' | translate }}
            </h4>
            <div class="d-flex flex-column text-center">
              <h5>{{ timestampToDate(policy.desactivationDate) }}</h5>
              <h6>{{ horaire(policy.desactivationDate) }}</h6>
            </div>
            }
            @if (policy?.status == 'REFUSED' && policy.refusedDate) {
            <h4 class="elemTitre text-center">
              {{ 'security-policies-active-list-refused-date' | translate }}
            </h4>
            <div class="d-flex flex-column text-center">
              <h5>{{ timestampToDate(policy.refusedDate) }}</h5>
              <h6>{{ horaire(policy.refusedDate) }}</h6>
            </div>
            }
          </div>
          <img class="side-arrow" src="assets/icons/ComprReport/down-arrow.svg">
        </div>
        }
        
      </div>
      }
    </div>
    } @else {
    <app-loading-error [boolean]="false" [search]="'component-error-search-policies' | translate">
    </app-loading-error>
    }
    <div id="policyInfos" hidden="hidden">
      <app-details-policy (editPtoMain)="editPolicy($event)" (status)="patchStatus($event)"
        (deletePtoMain)="deleteP($event)" (duplicateEvent)="duplicate($event)" [type]="'active'"
        [policy]="currentpolicy">
      </app-details-policy>
    </div>
  </div>
  } @else {
  @if (loadingOerror()) {
  <app-loading-error [boolean]="true" [message]="'waiting-for-policies' | translate">
  </app-loading-error>
  }
  }
  <app-toast-component></app-toast-component>
</div>